import { Dropdown, DropdownItem } from "nectar-ui";
import React from "react";
import {
  DASHBOARD_CHART_VISUALIZATION_TYPES,
  DashboardChartVisualizationKeys,
} from "@utils/constants/dashboard/dashboardModuleConstants";

import DashboardFilterButton from "../../DashboardFilterButton";

export type ChartTypeFilterOption =
  (typeof DASHBOARD_CHART_VISUALIZATION_TYPES)[DashboardChartVisualizationKeys];

interface DashboardChartTypeFilterProps {
  currentFilter: ChartTypeFilterOption;
  setFilter: (filter: ChartTypeFilterOption) => void;
  allowedOptions?: ChartTypeFilterOption[];
}

const DashboardChartTypeFilter = ({
  currentFilter,
  setFilter,
  allowedOptions,
}: DashboardChartTypeFilterProps) => {
  const filterOptions = allowedOptions || Object.values(DASHBOARD_CHART_VISUALIZATION_TYPES);

  const chartTypeDropdownOptions = filterOptions.map((filterOption) => (
    <DropdownItem key={filterOption.value} onClick={() => setFilter(filterOption)}>
      {filterOption.label}
    </DropdownItem>
  ));

  return (
    <div style={{ position: "relative" }}>
      <Dropdown
        position="left"
        action={<DashboardFilterButton>{currentFilter.label}</DashboardFilterButton>}
        options={chartTypeDropdownOptions}
      />
    </div>
  );
};

export default DashboardChartTypeFilter;
